import { useDataChange } from 'Simple/Data'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.sidebar.is_floating = true
      next.sidebar.is_floating_and_visible = false
    })
  }
}
